import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Desplaza la ventana al inicio (0, 0) cada vez que cambia la ruta
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant' // 'instant' es inmediato, puedes usar 'smooth' si prefieres animación
    });
  }, [pathname]);

  return null;
};

export default ScrollToTop;